import { createStyles } from '@material-ui/styles';

export default (value: string) =>
  createStyles({
    textContainer: {
      width: '100%',
    },
    icon: {
      color: value,
    },
  });
